import LocationMarkIcon from 'assets/icons/LocationMarkIcon';
import './styles.scss';
import { useState } from 'react';

const DPHotspot = ({ data, onClickHotspot }) => {
  const [isActive, setIsActive] = useState(false);
  return (
    <div className="dp-hotspot-container">
      <div className="dp-hotspot-content">
        <div className={`dp-hotspot-content-inner ${isActive ? 'active' : ''}`}>
          <div
            className={`dp-hotspot-content-inner-line ${
              isActive ? 'active' : ''
            }`}
          >
            <p>{data.title}</p>
          </div>
        </div>
        <div
          className="icon"
          onClick={onClickHotspot}
          onMouseEnter={() => setIsActive(true)}
          onMouseLeave={() => setIsActive(false)}
        >
          <LocationMarkIcon />
        </div>
      </div>
    </div>
  );
};

export default DPHotspot;
